import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa"; // Importing the profile icon
import CityList from "../CityList/CityList";
import { main_logo } from "../../Utils/export";
import { getUserData } from "../../Utils/localStorageUtils";
import useUserLocation from "../../hooks/useUserLocation";
import { updateCity } from "../../Redux/slices/locationSlice";
import { useDispatch, useSelector } from "react-redux";
import useCustomNavigate from "../../hooks/useCustomNavigate";

function Navbar({ setNavbarHeight }) {
  const dispatch = useDispatch()

  const {goToNewTab} = useCustomNavigate()

  const { location, error, fetchLocation } = useUserLocation();
  const [showCityList, setShowCityList] = useState(false);
  const [selectedCity, setSelectedCity] = useState("New Delhi");  // Default city
  const navbarRef = useRef(null);
  const navigate = useNavigate(); // For navigation to /profile
  const isLogin = getUserData();
console.log("locationlocation",location)
  // Fetch location on component mount
  useEffect(() => {
    fetchLocation();
  }, []);

  
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const locationData = queryParams.get('location'); // Get the 'location' query parameter
  
    // Check if locationData exists in the URL and parse it
    if (locationData) {
      const decodedLocation = JSON.parse(decodeURIComponent(locationData)); // Decode and parse the location data
      const cityFromUrl = decodedLocation?.city; // Extract the city from the decoded location
  
      // If city data exists in the URL, set the selected city
      if (cityFromUrl) {
        setSelectedCity(cityFromUrl);
      } else if (location?.city) {
        // If URL doesn't have city, fall back to location from useUserLocation
        setSelectedCity(location.city);
      }
    } else if (location?.city) {
      // If no locationData in URL, fall back to location from useUserLocation
      setSelectedCity(location.city);
    }
  }, [location]); // Run this effect once when component mounts and when location changes
  

  useEffect(() => {
    if (navbarRef.current) {
      // Pass the height of the Navbar to the SubNavBar
      setNavbarHeight && setNavbarHeight(navbarRef.current.offsetHeight);
    }
  }, [setNavbarHeight]);

  // Handle city selection from CityList
  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setShowCityList(false); // Close city list after selection
    console.log("citycitycity",city);
    
    dispatch(updateCity(city))
  };

  return (
    <div
      ref={navbarRef}
      className="flex top-0 left-0 fixed w-full h-[72px] z-50 justify-between px-6 bg-gray-100 border-b border-gray-300"
    >
      {/* Left Section: Logo and City */}
      <div className="flex gap-6">
        <div className="flex items-center">
          <div className="h-14 w-14 flex items-center justify-center">
            <Link to="/" className="block">
              <img
                src={main_logo}
                loading="lazy"
                alt="Logo"
                className="h-full w-full object-contain"
              />
            </Link>
          </div>
        </div>

        <div
          className="relative flex items-center gap-1 font-bold text-lg cursor-pointer"
          onMouseEnter={() => setShowCityList(true)}
          onMouseLeave={() => setShowCityList(false)}
        >
          <p className="transition duration-150 ease-in-out">{selectedCity}</p>
          <span className="text-sm">&#9660;</span>

          {showCityList && (
             <div className="absolute left-0 top-full bg-white shadow-lg rounded-md">
             <CityList onCitySelect={handleCitySelect}/>
           </div>
          )}
        </div>
      </div>

      {/* Right Section: Buttons */}
      <div className="flex items-center gap-4">
        <Link
          to="/bankaunction"
          className="px-4 py-2 bg-white text-green-900 border border-green-900 rounded-md hover:bg-green-900 hover:text-white transition"
        >
          Bank Auction
        </Link>

        {/* Add Property Dropdown with Arrow */}
        <div className="relative group">
          <button
            className="px-4 py-2 bg-white text-green-900 border border-green-900 rounded-md hover:bg-green-900 hover:text-white transition"
          >
            Post
          </button>
          <div className="absolute right-0 top-full mt-2 bg-white shadow-lg rounded-md w-[140px] opacity-0 group-hover:opacity-100 transition-opacity">
            {/* The arrow triangle */}
            <div className="absolute right-0 transform -translate-x-1/2 -top-2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-black"></div>
            <Link
              to="/addproperty"
              className="block px-4 py-2 text-green-900 hover:bg-green-900 hover:text-white"
            >
              Property
            </Link>
            <Link
              to="/addproject"
              className="block px-4 py-2 text-green-900 hover:bg-green-900 hover:text-white"
            >
              Project
            </Link>
          </div>
        </div>

        {isLogin ? (
          // Profile Icon
          <FaUserCircle
            className="text-3xl text-blue-700 cursor-pointer hover:text-blue-800 transition"
            onClick={() => goToNewTab("https://one-two-one-admin-panel.vercel.app")}
          />
        ) : (
          // Login Button
          <Link
            to="/login"
            className="px-5 py-2 bg-blue-700 text-white rounded-md hover:bg-blue-800 transition"
          >
            Login
          </Link>
        )}
      </div>
    </div>
  );
}

export default Navbar;
